import React, { useState } from 'react';
import { FaChevronLeft, FaChevronRight, FaTimes, FaHeart, FaRegHeart } from 'react-icons/fa';
import './model.css';
import Popupbox from './Popupbox';

const modelsData = [
  {
    id: 1,
    name: 'Kabir Singhania',
    age: 24,
    city: 'Mumbai',
    height: `6'1"`,
    hair: 'Black',
    eyes: 'Dark Brown',
    coverImage: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=500&auto=format&fit=crop&q=60',
    photos: [
      'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1492562080023-ab3db95bfbce?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1480429370139-e0132c086e2a?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1539571696357-5a69c17a67c6?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1522075469751-3a6694fb2f61?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1501196354995-cbb51c65aaea?w=900&auto=format&fit=crop&q=80',
    ],
  },
  {
    id: 2,
    name: 'Aryan Rathore',
    age: 26,
    city: 'Delhi',
    height: `6'0"`,
    hair: 'Dark Brown',
    eyes: 'Hazel',
    coverImage: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=500&auto=format&fit=crop&q=60',
    photos: [
      'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1492562080023-ab3db95bfbce?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1539571696357-5a69c17a67c6?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1480429370139-e0132c086e2a?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1522075469751-3a6694fb2f61?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1501196354995-cbb51c65aaea?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=900&auto=format&fit=crop&q=80',
    ],
  },
  {
    id: 3,
    name: 'Dev Mehra',
    age: 23,
    city: 'Bangalore',
    height: `5'11"`,
    hair: 'Black',
    eyes: 'Brown',
    coverImage: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=500&auto=format&fit=crop&q=60',
    photos: [
      'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1492562080023-ab3db95bfbce?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1539571696357-5a69c17a67c6?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1480429370139-e0132c086e2a?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1522075469751-3a6694fb2f61?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1501196354995-cbb51c65aaea?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=900&auto=format&fit=crop&q=80',
    ],
  },
  {
    id: 4,
    name: 'Siddharth Roy',
    age: 28,
    city: 'Mumbai',
    height: `6'2"`,
    hair: 'Dark Brown',
    eyes: 'Dark Brown',
    coverImage: 'https://images.unsplash.com/photo-1539571696357-5a69c17a67c6?w=500&auto=format&fit=crop&q=60',
    photos: [
      'https://images.unsplash.com/photo-1539571696357-5a69c17a67c6?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1492562080023-ab3db95bfbce?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1480429370139-e0132c086e2a?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1522075469751-3a6694fb2f61?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1501196354995-cbb51c65aaea?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=900&auto=format&fit=crop&q=80',
      'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=900&auto=format&fit=crop&q=80',
    ],
  },
];

function MaleModel() {
  const [selectedModel, setSelectedModel] = useState(null);
  const [activePhotoIndex, setActivePhotoIndex] = useState(0);
  const [shortlisted, setShortlisted] = useState([]);
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const openModelViewer = (model) => {
    setSelectedModel(model);
    setActivePhotoIndex(0);
  };

  const closeModelViewer = () => {
    setSelectedModel(null);
  };

  const handlePrev = () => {
    if (!selectedModel) return;
    setActivePhotoIndex((prev) =>
      prev === 0 ? selectedModel.photos.length - 1 : prev - 1
    );
  };

  const handleNext = () => {
    if (!selectedModel) return;
    setActivePhotoIndex((prev) =>
      prev === selectedModel.photos.length - 1 ? 0 : prev + 1
    );
  };

  const toggleShortlist = (id) => {
    setShortlisted((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
  };

  return (
    <div className="female-model-page">
      <div className="page-container">
        <header className="page-header">
          <h1 className="page-title">Female Child Models</h1>
          <p className="page-desc">
            Discover aspiring and professional child artists for TV commercials, print shoots, kids fashion brands, and cinema. Click on any artist to preview their compcard portfolio.
          </p>
        </header>

        {/* Grid List */}
        <div className="models-grid">
          {modelsData.map((model) => (
            <div
              key={model.id}
              className="model-card"
              onClick={() => openModelViewer(model)}
            >
              <div className="card-image-wrapper">
                <img src={model.coverImage} alt={model.name} className="model-img" />
              </div>
              <div className="model-info">
                <span className="model-name">
                  {model.name} ( AGE {model.age} )
                </span>
                <span className="model-city">{model.city}</span>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* FULL WINDOW LIGHTBOX MODAL */}
      {selectedModel && (
        <div className="modal-backdrop" onClick={closeModelViewer}>
          <div className="modal-window" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close-btn" onClick={closeModelViewer}>
              <FaTimes />
            </button>

            <div className="modal-split-body">
              <div className="slider-container">
                <button className="slider-arrow left-arrow" onClick={handlePrev} aria-label="Previous">
                  <FaChevronLeft />
                </button>
                <div className="slider-image-frame">
                  <img
                    src={selectedModel.photos[activePhotoIndex]}
                    alt={`${selectedModel.name} slide`}
                    className="slider-main-img"
                  />
                </div>
                <button className="slider-arrow right-arrow" onClick={handleNext} aria-label="Next">
                  <FaChevronRight />
                </button>
              </div>

              <div className="details-container">
                <div className="details-header">
                  <h2 className="details-name">{selectedModel.name}</h2>
                  <span className="details-city">{selectedModel.city}</span>
                </div>

                <div className="details-specs">
                  <div className="spec-row">
                    <span>Age</span>
                    <strong>{selectedModel.age} Years</strong>
                  </div>
                  <div className="spec-row">
                    <span>Height</span>
                    <strong>{selectedModel.height}</strong>
                  </div>
                  <div className="spec-row">
                    <span>Hair</span>
                    <strong>{selectedModel.hair}</strong>
                  </div>
                  <div className="spec-row">
                    <span>Eyes</span>
                    <strong>{selectedModel.eyes}</strong>
                  </div>
                </div>

                <div className="details-actions">
                  <button
                    className="shortlist-btn"
                    onClick={() => toggleShortlist(selectedModel.id)}
                  >
                    {shortlisted.includes(selectedModel.id) ? (
                      <>
                        <FaHeart className="heart-icon-filled" /> Shortlisted
                      </>
                    ) : (
                      <>
                        <FaRegHeart /> Shortlist Model
                      </>
                    )}
                  </button>
                  <button 
                    className="enquire-btn"
                    onClick={() => setIsPopupOpen(true)}
                  >
                    Enquire About Artist
                  </button>
                </div>
              </div>
            </div>

            <div className="modal-thumbnails-bar">
              <span className="thumbnails-title">
                Photos ({activePhotoIndex + 1} / {selectedModel.photos.length}):
              </span>
              <div className="thumbnails-track">
                {selectedModel.photos.map((photo, index) => (
                  <div
                    key={index}
                    className={`thumbnail-item ${index === activePhotoIndex ? 'active-thumb' : ''}`}
                    onClick={() => setActivePhotoIndex(index)}
                  >
                    <img src={photo} alt="thumbnail" />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Render the WhatsApp popup with the selected model's name */}
      <Popupbox 
        isOpen={isPopupOpen} 
        onClose={() => setIsPopupOpen(false)} 
        defaultModelName={selectedModel ? selectedModel.name : ''} 
      />
    </div>
  );
}

export default MaleModel;